import { ExclamationCircleOutlined } from "@ant-design/icons"
import { Tooltip } from "antd"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"
import { ORANGE } from "App.scss"

interface DeletedSelectOptionInterface {
    translationKey: string
    deletionDate?: Date
    className?: string
}
const DeletedTooltip: React.FC<DeletedSelectOptionInterface> = ({ translationKey, deletionDate, className }) => {
    const { t } = useTranslation()

    return (
        <Tooltip
            color={ORANGE}
            title={t(translationKey, {
                date: moment(deletionDate).format("DD.MM.YYYY"),
            })}
        >
            <ExclamationCircleOutlined className={`${className ?? "ml-4"} inline-flex align-middle`} style={{ color: ORANGE }} />
        </Tooltip>
    )
}

export default DeletedTooltip
